import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/nimblr': {
    width: 355,
    height: 512,
    paths: [
      {
        d: 'M232.6 299.3C248.2 299.3 259.8 310.8 259.8 326.3 259.8 341.8 248.1 353.2 232.6 353.2 216.9 353.2 205.4 341.6 205.4 326.3 205.4 310.7 217 299.3 232.6 299.3zM99 326.3C99 310.6 110.7 299.3 126.2 299.3 141.7 299.3 153.3 310.8 153.3 326.3 153.3 341.7 141.8 353.2 126.2 353.2 110.7 353.2 99 341.9 99 326.3M177.8 158.9C143 158.9 75.5 178.8 45.3 227L0 0V335.5C0 433.1 79.6 512 177.8 512 276 512 355.5 433.1 355.5 335.5 355.5 238 276.1 158.9 177.8 158.9zM177.8 467.1C104.5 467.1 45.3 408.2 45.3 335.5 45.3 262.8 104.5 203.9 177.8 203.9 251 203.9 310.3 262.8 310.3 335.5S251 467.1 177.8 467.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/nimblr.js
// module id = 8aGY
// module chunks = 144